module.exports = __webpack_public_path__ + "img/delete_emp.aa1931f3.svg";